/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useState, useMemo, useEffect, Fragment } from "react";
import {
  Nav,
  Tab,
  Dropdown,
  OverlayTrigger,
  Tooltip,
  Row,
  Col,
} from "react-bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import SVG from "react-inlinesvg";
import objectPath from "object-path";
import { useHtmlClassService } from "../../../_core/MetronicLayout";
import { toAbsoluteUrl } from "../../../../_helpers";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";
import { useTranslation } from "react-i18next";
import {
  myFirestore,
  onMessageListener,
  requestForToken,
} from "../../../../../app/modules/Chat/Config/firebase";
import { Link, useHistory } from "react-router-dom";
import {
  AppString,
  timeSince,
  truncateString,
} from "../../../../../app/modules/Chat/Component/Const";
const perfectScrollbarOptions = {
  wheelSpeed: 2,
  wheelPropagation: false,
};

export function UserNotificationsDropdown() {
  const [key, setKey] = useState("Events");
  const [notificationsList, setNotificationsList] = useState([]);
  const [notification, setNotification] = useState(null);
  const [showDot, setShowDot] = useState(false);
  const [loader, setLoader] = useState(false);
  const { t } = useTranslation();
  const bgImage = toAbsoluteUrl("/media/misc/bg-1.jpg");
  const uiService = useHtmlClassService();
  const history = useHistory();
  const layoutProps = useMemo(() => {
    return {
      offcanvas:
        objectPath.get(uiService.config, "extras.notifications.layout") ===
        "offcanvas",
    };
  }, [uiService]);

  //getting notifications
  useEffect(() => {
    requestForToken();
    onMessageListener(setNotification);
  }, []);
  useEffect(() => {
    fetchDataLocalStorage();
  }, []);
  async function fetchDataLocalStorage() {
    try {
      setLoader(true);
      const id = localStorage.getItem(AppString.ID);
      const data = await myFirestore
        .collection(AppString.NODE_NOTIFICATIONS)
        .where("shipperId", "==", id?.toString())
        .get();
      let result = [];
      if (data.docs.length > 0) {
        data.forEach((s) => {
          result.push({
            Message: s.data().message,
            Header: s.data().header,
            id: s.data().id,
            loadCode: s.data().loadCode,
            type: s.data().type,
            body : s.data().body,
            Date: s.data().date,
            timestamp : s.data().timestamp,
            uid : s.data().uid,
            loadId : s.data().loadId,
          });
        });
      }
      result = result.sort(function(a, b) {
        return b.timestamp - a.timestamp;
      });
      console.log('rrrs',result);
      setTimeout(() => {
        setNotificationsList(result ?? []);
        setLoader(false);
      },500);
    } catch (err) {
      setLoader(false);
    }
  }

  async function DeleteNotificationItem(userId, loadId,code) {
    try {
      if (!!code) {
        const data = await myFirestore
          .collection(AppString.NODE_NOTIFICATIONS)
          .where("uid", "==", code?.toString())
          .get();
          if(data.docs.length > 0){
            data.docs[0].ref.delete();
          }
      } else {
        const data = await myFirestore
          .collection(AppString.NODE_NOTIFICATIONS)
          .doc(userId + "-" + loadId)
          .get();
        data.ref.delete();
      }

      //reload
      await fetchDataLocalStorage();
    } catch (err) {
      console.log("err", err);
    }
  }

  async function DeleteNotificationAll() {
    try {
      const id = localStorage.getItem(AppString.ID);
      const data = await myFirestore
        .collection(AppString.NODE_NOTIFICATIONS)
        .where("shipperId", "==", id?.toString())
        .get();
      data.forEach((s) => {
        if (s) s.ref.delete();
      });

      //reload
      setTimeout(async () => {
        await fetchDataLocalStorage();
      }, 100);
    } catch (err) {
      console.log("err", err);
    }
  }
  useEffect(() => {
    try {
      if (notification) {
        fetchDataLocalStorage();
        setShowDot(true);
      }
    } catch (err) {
      console.log(err);
    }
  }, [notification]);

  return (
    <>
      {layoutProps.offcanvas && (
        <div className="topbar-item">
          <div
            className="btn btn-icon btn-clean btn-lg mr-1 pulse pulse-primary"
            id="kt_quick_notifications_toggle"
          >
            <span className="svg-icon svg-icon-xl svg-icon-primary">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Compiling.svg")} />
            </span>
            <span className="pulse-ring"></span>
          </div>
        </div>
      )}
      {!layoutProps.offcanvas && (
        <Dropdown drop="down" alignRight>
          <Dropdown.Toggle
            as={DropdownTopbarItemToggler}
            id="kt_quick_notifications_toggle"
          >
            {showDot && <span className="sec counter counter-lg"></span>}
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="user-notification-tooltip">
                  {t("User_Notifications")}
                </Tooltip>
              }
            >
              <div
                className="btn btn-icon btn-hover-transparent-white btn-dropdown btn-lg mr-1 pulse pulse-primary"
                id="kt_quick_notifications_toggle"
                onClick={() => {
                  setShowDot(false);
                  fetchDataLocalStorage();
                }}
              >
                <span className="svg-icon svg-icon-xl">
                  <i className="flaticon2-notification"></i>
                </span>
                <span className="pulse-ring" />
              </div>
            </OverlayTrigger>
          </Dropdown.Toggle>

          <Dropdown.Menu className="dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim-up dropdown-menu-lg">
            <form>
              {/** Head */}
              <div
                className="d-flex flex-column pt-12 bgi-size-cover bgi-no-repeat rounded-top"
                style={{ backgroundImage: `url(${bgImage})` }}
              >
                <h4 className="d-flex flex-center rounded-top">
                  <span className="text-white">{t("User_Notifications")}</span>
                  {/* {notificationsList?.filter((s) => s.userId !== undefined)
                    .length > 0 && (
                    <span className="btn btn-text btn-success btn-sm font-weight-bold btn-font-md ml-2">
                      {
                        notificationsList?.filter((s) => s.userId !== undefined)
                          .length
                      }{" "}
                      {t("new")}
                    </span>
                  )} */}
                </h4>

                <Tab.Container defaultActiveKey={key}>
                  <Nav
                    as="ul"
                    className="nav nav-bold nav-tabs nav-tabs-line nav-tabs-line-3x nav-tabs-line-transparent-white nav-tabs-line-active-border-success mt-3 px-8"
                    onSelect={(_key) => setKey(_key)}
                  >
                    <Nav.Item as="li">
                      <Nav.Link
                        eventKey="Events"
                        className={`nav-link show ${
                          key === "Events" ? "active" : ""
                        }`}
                      >
                        {t("Notification")}
                        <i
                          className="fas fa-trash text-danger ml-2"
                          onClick={async (e) => {
                            //clear notifications
                            await DeleteNotificationAll();
                            e.preventDefault();
                          }}
                          style={{ cursor: "pointer", fontSize: "12px" }}
                        ></i>
                        {/* <i
                          className="flaticon2-refresh-1 text-info ml-md-8"
                          onClick={async (e) => {
                            await fetchDataLocalStorage();
                            e.preventDefault();
                          }}
                          style={{ cursor: "pointer", fontSize: "12px" }}
                        ></i> */}
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>

                  <Tab.Content className="tab-content">
                    <Tab.Pane
                      eventKey="Events"
                      id="topbar_notifications_events"
                    >
                      <PerfectScrollbar
                        options={perfectScrollbarOptions}
                        className="navi navi-hover scroll my-4"
                        style={
                          notificationsList?.filter(
                            (s) => s.userId !== undefined
                          )?.length > 0
                            ? { maxHeight: "300px", position: "relative" }
                            : {
                                textAlignLast: "center",
                                maxHeight: "300px",
                                position: "relative",
                              }
                        }
                      >
                        {notificationsList?.length > 0 ? (
                          loader ? (
                            <span className="text-muted">Loading ...</span>
                          ) : (
                            notificationsList.map((x, i) =>
                              x?.type === "update_load" ||
                              x?.type === "assign_load" ||
                              x?.type === "assign_d2d" ||
                              x?.type === "unassign_d2d" ||
                              x?.type === "add_bid" ||
                              x?.type === "update_bid" ||
                              x?.type === "accept_load" ? (
                                <span className="navi-item" key={i}>
                                  <div
                                    className="navi-link"
                                  >
                                    <div
                                      className="navi-icon mr-4"
                                      style={{
                                        bottom: "10px",
                                        position: "relative",
                                      }}
                                    >
                                      {x?.type === "add_bid" ||
                                      x?.type === "update_bid" ? (
                                        <i
                                          className="flaticon-price-tag text-warning"
                                          style={{ fontSize: "24px" }}
                                        ></i>
                                      ) : (
                                        <i
                                          className="flaticon2-box flaticon2-line- text-info"
                                          style={{ fontSize: "24px" }}
                                        ></i>
                                      )}
                                    </div>
                                    <div className="navi-text">
                                      <span
                                        key={i}
                                        style={{ cursor: "pointer" }}
                                      >
                                        <div
                                          className="font-weight-bold"
                                          style={{ textAlignLast: "left" }}
                                          onClick={() => {
                                            if (!!x?.loadId) {
                                              if (
                                                x?.type === "add_bid" ||
                                                x?.type === "update_bid"
                                              ) {
                                                history.push(
                                                  `/shipper/Loads/${x?.loadId}/edit`
                                                );
                                              } else {
                                                history.push(
                                                  `/trackload/${x?.loadId}/details`
                                                );
                                              }
                                            }
                                          }}
                                        >
                                          {x?.body}
                                        </div>
                                      </span>
                                      <div className="text-muted">
                                        <Row>
                                          <Col
                                            lg="12"
                                            style={{
                                              whiteSpace: "nowrap",
                                              textAlignLast: "right",
                                            }}
                                          >
                                            {" "}
                                            <span>{timeSince(x?.timestamp)}</span>
                                          </Col>
                                        </Row>
                                      </div>
                                    </div>
                                    <div
                                      className="navi-icon iconDelete"
                                      style={{ cursor: "pointer" }}
                                    >
                                      <i
                                        onClick={async (e) => {
                                          await DeleteNotificationItem(
                                            x?.id,
                                            x?.loadCode,
                                            x?.uid
                                          );
                                          e.preventDefault();
                                        }}
                                        className="flaticon2-cross flaticon2-line- text-danger"
                                        style={{ fontSize: "10px" }}
                                      ></i>
                                    </div>
                                  </div>
                                </span>
                              ) : (
                                <div className="navi-item" key={i}>
                                  <div className="navi-link">
                                    <div
                                      className="navi-icon mr-4"
                                      style={{
                                        bottom: "10px",
                                        position: "relative",
                                      }}
                                    >
                                      <i
                                        className="flaticon-mail text-success"
                                        style={{ fontSize: "24px" }}
                                      ></i>
                                    </div>
                                    <div className="navi-text">
                                      <Link
                                        key={i}
                                        style={{ cursor: "pointer" }}
                                        to={`/Messages?userId=${x?.id}`}
                                      >
                                        <div
                                          className="font-weight-bold"
                                          style={{ textAlignLast: "left" }}
                                        >
                                          {x?.Header}
                                        </div>
                                      </Link>
                                      <div className="text-muted">
                                        <Row>
                                          <Col
                                            lg="10"
                                            style={{ textAlignLast: "left" }}
                                          >
                                            {x?.Message?.includes(
                                              "https://firebasestorage.googleapis.com"
                                            ) ? (
                                              <Fragment>
                                                <i className="flaticon2-image-file text-muted mr-2"></i>
                                                <span>Image</span>
                                              </Fragment>
                                            ) : (
                                              <span>{`${truncateString(
                                                x?.Message,
                                                30
                                              )}`}</span>
                                            )}
                                          </Col>
                                          <Col
                                            lg="2"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            {" "}
                                            <span>{timeSince(x?.timestamp)}</span>
                                          </Col>
                                        </Row>
                                      </div>
                                    </div>
                                    <div
                                      className="navi-icon iconDelete"
                                      style={{ cursor: "pointer" }}
                                    >
                                      <i
                                        onClick={async (e) => {
                                          await DeleteNotificationItem(
                                            x?.id,
                                            x?.loadCode,
                                            x?.uid
                                          );
                                          e.preventDefault();
                                        }}
                                        className="flaticon2-cross flaticon2-line- text-danger"
                                        style={{ fontSize: "10px" }}
                                      ></i>
                                    </div>
                                  </div>
                                </div>
                              )
                            )
                          )
                        ) : (
                          <span className="text-muted">
                            No Notifications yet!
                          </span>
                        )}

                        {/* <a href="#" className="navi-item">
                          <div className="navi-link">
                            <div className="navi-icon mr-2">
                              <i className="flaticon2-line-chart text-success"></i>
                            </div>
                            <div className="navi-text">
                              <div className="font-weight-bold">
                                New report has been received
                              </div>
                              <div className="text-muted">23 hrs ago</div>
                            </div>
                          </div>
                        </a>

                        <a href={()=>false} className="navi-item">
                          <div className="navi-link">
                            <div className="navi-icon mr-2">
                              <i className="flaticon2-paper-plane text-danger"></i>
                            </div>
                            <div className="navi-text">
                              <div className="font-weight-bold">
                                Finance report has been generated
                              </div>
                              <div className="text-muted">25 hrs ago</div>
                            </div>
                          </div>
                        </a>

                        <a href={()=>false} className="navi-item">
                          <div className="navi-link">
                            <div className="navi-icon mr-2">
                              <i className="flaticon2-user flaticon2-line- text-success"></i>
                            </div>
                            <div className="navi-text">
                              <div className="font-weight-bold">
                                New order has been received
                              </div>
                              <div className="text-muted">2 hrs ago</div>
                            </div>
                          </div>
                        </a>

                        <a href={()=>false} className="navi-item">
                          <div className="navi-link">
                            <div className="navi-icon mr-2">
                              <i className="flaticon2-pin text-primary"></i>
                            </div>
                            <div className="navi-text">
                              <div className="font-weight-bold">
                                New customer is registered
                              </div>
                              <div className="text-muted">3 hrs ago</div>
                            </div>
                          </div>
                        </a>

                        <a href={()=>false} className="navi-item">
                          <div className="navi-link">
                            <div className="navi-icon mr-2">
                              <i className="flaticon2-sms text-danger"></i>
                            </div>
                            <div className="navi-text">
                              <div className="font-weight-bold">
                                Application has been approved
                              </div>
                              <div className="text-muted">3 hrs ago</div>
                            </div>
                          </div>
                        </a>

                        <a href={()=>false} className="navi-item">
                          <div className="navi-link">
                            <div className="navi-icon mr-2">
                              <i className="flaticon2-pie-chart-3 text-warning"></i>
                            </div>
                            <div className="navinavinavi-text">
                              <div className="font-weight-bold">
                                New file has been uploaded
                              </div>
                              <div className="text-muted">5 hrs ago</div>
                            </div>
                          </div>
                        </a>

                        <a href={()=>false} className="navi-item">
                          <div className="navi-link">
                            <div className="navi-icon mr-2">
                              <i className="flaticon-pie-chart-1 text-info"></i>
                            </div>
                            <div className="navi-text">
                              <div className="font-weight-bold">
                                New user feedback received
                              </div>
                              <div className="text-muted">8 hrs ago</div>
                            </div>
                          </div>
                        </a>

                        <a href={()=>false} className="navi-item">
                          <div className="navi-link">
                            <div className="navi-icon mr-2">
                              <i className="flaticon2-settings text-success"></i>
                            </div>
                            <div className="navi-text">
                              <div className="font-weight-bold">
                                System reboot has been successfully completed
                              </div>
                              <div className="text-muted">12 hrs ago</div>
                            </div>
                          </div>
                        </a>

                        <a href={()=>false} className="navi-item">
                          <div className="navi-link">
                            <div className="navi-icon mr-2">
                              <i className="flaticon-safe-shield-protection text-primary"></i>
                            </div>
                            <div className="navi-text">
                              <div className="font-weight-bold">
                                New order has been placed
                              </div>
                              <div className="text-muted">15 hrs ago</div>
                            </div>
                          </div>
                        </a>

                        <a href={()=>false} className="navi-item">
                          <div className="navi-link">
                            <div className="navi-icon mr-2">
                              <i className="flaticon2-notification text-primary"></i>
                            </div>
                            <div className="navi-text">
                              <div className="font-weight-bold">
                                Company meeting canceled
                              </div>
                              <div className="text-muted">19 hrs ago</div>
                            </div>
                          </div>
                        </a>

                        <a href={()=>false} className="navi-item">
                          <div className="navi-link">
                            <div className="navi-icon mr-2">
                              <i className="flaticon2-fax text-success"></i>
                            </div>
                            <div className="navi-text">
                              <div className="font-weight-bold">
                                New report has been received
                              </div>
                              <div className="text-muted">23 hrs ago</div>
                            </div>
                          </div>
                        </a>

                        <a href={()=>false} className="navi-item">
                          <div className="navi-link">
                            <div className="navi-icon mr-2">
                              <i className="flaticon-download-1 text-danger"></i>
                            </div>
                            <div className="navi-text">
                              <div className="font-weight-bold">
                                Finance report has been generated
                              </div>
                              <div className="text-muted">25 hrs ago</div>
                            </div>
                          </div>
                        </a>

                        <a href={()=>false} className="navi-item">
                          <div className="navi-link">
                            <div className="navi-icon mr-2">
                              <i className="flaticon-security text-warning"></i>
                            </div>
                            <div className="navi-text">
                              <div className="font-weight-bold">
                                New customer comment recieved
                              </div>
                              <div className="text-muted">2 days ago</div>
                            </div>
                          </div>
                        </a>

                        <a href={()=>false} className="navi-item">
                          <div className="navi-link">
                            <div className="navi-icon mr-2">
                              <i className="flaticon2-analytics-1 text-success"></i>
                            </div>
                            <div className="navi-text">
                              <div className="font-weight-bold">
                                New customer is registered
                              </div>
                              <div className="text-muted">3 days ago</div>
                            </div>
                          </div>
                        </a> */}
                      </PerfectScrollbar>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>
            </form>
          </Dropdown.Menu>
        </Dropdown>
      )}
    </>
  );
}
